var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":_vm.title,"show-close-button":true,"cancel-text":"Cancel","submit-text":"Save","disable-submit-button":_vm.isSaving,"close-on-outside-click":false},on:{"submit":function($event){return _vm.$emit('submit', _vm.image)},"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"container"},[_c('cropper',{ref:"cropper",staticClass:"cropper",style:({
        width: `${_vm.width}px`,
        height: `${_vm.height}px`,
      }),attrs:{"backgroundClass":"bg-white","stencil-component":"circle-stencil","stencil-props":{
        aspectRatio: _vm.aspectRatio,
      },"src":_vm.file.src},on:{"change":_vm.cropperChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }